import React from 'react'

function Subscribe() {
  return (
    <div>Subscribe</div>
  )
}

export default Subscribe